import { createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  indexing: '',
  meta_title: '',
  meta_description: '',
};

const seoSettingsSlice = createSlice({
  name: 'seoSettingSlice',
  initialState,
  reducers: {
    setIndexing: (state, action) => {
      state.indexing = action.payload;
    },
  },
});


export const seoSettingField = (state) => state?.seoSettings || '';

export const { setIndexing } = seoSettingsSlice.actions;

export default seoSettingsSlice.reducer;
